<template>
  <div>
    <WriteSqlModal ref="WriteSqlModal" v-on:complete="writeSQLComplete"></WriteSqlModal>
    <Spin fix v-show="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>加载中</div>
    </Spin>
    <Alert v-if="error" show-icon type="error">获取数据失败<a style="float: right" v-on:click="resetForm">重新获取</a></Alert>
    <div style="margin-top: 5px" v-else>
      <Form inline ref="editForm" :model="editForm" :label-width="80">
        <Row>
          <Col span="10">
            <Row style="height: 30px">
              <FormItem label="事件名称">
                <Input size="small" v-model="editForm.name" style="width: 400px" />
              </FormItem>
            </Row>
            <Row style="height: 30px">
              <FormItem label="定义者">
                <Input size="small" v-model="editForm.definer" style="width: 400px"/>
              </FormItem>
            </Row>
            <Row style="height: 30px">
              <FormItem label="到期后删除" style="width: 400px">
                <Checkbox v-model="editForm.preserve"></Checkbox>
              </FormItem>
            </Row>
            <Row style="height: 30px">
              <FormItem label="状态">
                <RadioGroup v-model="editForm.event_status" style="width: 400px">
                  <Radio label="ENABLE"></Radio>
                  <Radio label="DISABLE"></Radio>
                </RadioGroup>
              </FormItem>
            </Row>
            <Row style="height: 60px">
              <FormItem label="注释">
                <Input v-model="editForm.comment" type="textarea" :rows="2" placeholder="" style="width: 400px"/>
              </FormItem>
            </Row>
          </Col>
          <Col span="14">
            <FormItem>
              <RadioGroup v-model="editForm.event_type">
                <Row style="height: 40px">
                  <Col span="6">
                    <Radio :label="0">
                      <span>单次执行</span>
                    </Radio>
                  </Col>
                  <Col span="18">
                    <DatePicker :disabled="editForm.event_type===1" size="small" type="datetime" placeholder="" v-model="editForm.execute_time" style="width: 400px"></DatePicker>
                  </Col>
                </Row>
                <Row  style="height: 40px">
                  <Row  style="height: 40px">
                    <Col span="6">
                      <Radio :label="1">
                        <span>循环执行</span><span>每：</span>
                      </Radio>
                    </Col>
                    <Col span="18">
                      <Col span="8">
                        <label>
                          <Input v-model="editForm.interval_value" size="small" style="width: 100px;" :disabled="editForm.event_type===0"/>
                        </label>
                      </Col>
                      <Col span="16">
                        <Select :disabled="editForm.event_type===0" size="small" v-model="editForm.unit" style="width: 280px" placeholder="">
                          <Option :label="item.label" :value='item.value' v-for="(item, index) in unitList"
                                  :key="index"></Option>
                        </Select>
                      </Col>
                    </Col>
                  </Row>
                  <Row  style="height: 40px">
                    <Col span="6">
                      <span>开始时间</span>
                    </Col>
                    <Col span="18">
                      <DatePicker v-model="editForm.start_time" :disabled="editForm.event_type===0" size="small" type="datetime" format="yyyy-MM-dd HH:mm:ss" placeholder="" style="width: 400px"></DatePicker>
                    </Col>
                  </Row>
                  <Row  style="height: 40px">
                    <Col span="6">
                      <span>结束时间：</span>
                    </Col>
                    <Col span="18">
                      <DatePicker v-model="editForm.end_time" :disabled="editForm.event_type===0" size="small" type="datetime" format="yyyy-MM-dd HH:mm:ss" placeholder="" style="width: 400px"></DatePicker>
                    </Col>
                  </Row>
                </Row>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
      </Form>
    <Divider style="height: 20px; margin: 0; background-color: #f5f7f9"></Divider>
      <div class="ace-editor" :id="id"></div>
      <div class="info-edit-form-button">
        <Button type="primary" @click="ok" :loading="executing">提交</Button>
        <Button type="default" @click="resetForm" style="margin-left: 10px">重置</Button>
      </div>
    </div>
    <Modal title="执行结果" v-model="execResultModal" width="1000" footer-hide>
      <SQLResults ref="SQLResults" :callbackdata="callbackdata" :log="false"></SQLResults>
    </Modal>
  </div>
</template>

<script>
import { getEventData, createEvent, alterEvent, executeSQL } from '@/api/mysql'
import moment from 'moment'
import SQLResults from './sqlResults'
import WriteSqlModal from './writeSqlModal'
import '@/view/database/ace-export'
import { iRandom } from '@/libs/tools'

export default {
  name: 'dbEventEdit',
  components: {
    SQLResults,
    WriteSqlModal
  },
  data () {
    return {
      themePath: 'ace/theme/sqlserver',
      modePath: 'ace/mode/sql',
      aceEditor: '',
      old_data: {},
      editForm: {
        name: '',
        definer: '',
        preserve: true,
        comment: '',
        event_type: 1,
        execute_time: '',
        interval_value: '',
        unit: '',
        event_status: 'ENABLE',
        start_time: '',
        end_time: ''
      },
      id: 'edit-event-ace-editor' + iRandom(),
      execResultModal: false,
      executing: false,
      loading: false,
      error: false,
      unitList: [
        {
          value: 'YEAR',
          label: 'YEAR'
        },
        {
          value: 'QUARTER',
          label: 'QUARTER'
        },
        {
          value: 'MONTH',
          label: 'MONTH'
        },
        {
          value: 'DAY',
          label: 'DAY'
        },
        {
          value: 'HOUR',
          label: 'HOUR'
        },
        {
          value: 'MINUTE',
          label: 'MINUTE'
        },
        {
          value: 'WEEK',
          label: 'WEEK'
        },
        {
          value: 'SECOND',
          label: 'SECOND'
        },
        {
          value: 'YEAR_MONTH',
          label: 'YEAR_MONTH'
        },
        {
          value: 'DAY_HOUR',
          label: 'DAY_HOUR'
        },
        {
          value: 'DAY_MINUTE',
          label: 'DAY_MINUTE'
        },
        {
          value: 'DAY_SECOND',
          label: 'DAY_SECOND'
        },
        {
          value: 'HOUR_MINUTE',
          label: 'HOUR_MINUTE'
        },
        {
          value: 'HOUR_SECOND',
          label: 'HOUR_SECOND'
        },
        {
          value: 'MINUTE_SECOND',
          label: 'MINUTE_SECOND'
        }
      ]
    }
  },
  props: {
    callbackdata: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  created: function () {
    if (this.callbackdata.event) {
      this.init()
    }
  },
  mounted: function () {
    this.aceEditor = ace.edit(this.id, {
      maxLines: 30,
      minLines: 20,
      fontSize: 14,
      value: '',
      // status: 'ENABLE',
      theme: this.themePath,
      mode: this.modePath,
      wrap: 1,
      tabSize: 4
    })
    // 激活自动提示
    this.aceEditor.setOptions({
      enableSnippets: true,
      enableLiveAutocompletion: true,
      enableBasicAutocompletion: true,
      printMargin: false,
      printMarginColumn: 120
    })
    if (!this.callbackdata.event) {
      this.aceEditor.setValue('BEGIN\n' +
        '\t#Event body goes here...\n' +
        '\n' +
        'END;')
    }
  },
  methods: {
    init () {
      let params = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        event: this.callbackdata.event
      }
      this.loading = true
      this.error = false
      getEventData(params).then(res => {
        if (res.data.event.length) {
          this.editForm = result
          this.aceEditor.setValue(result.definition)
          this.old_data = JSON.parse(JSON.stringify(result))
        }
        this.loading = false
      }).catch(res => {
        this.loading = false
      })
    },

    ok () {
      let reqData = {
        name: this.editForm.name,
        event_type: this.editForm.event_type,
        definer: this.editForm.definer,
        comment: this.editForm.comment,
        preserve: this.editForm.preserve,
        event_status: this.editForm.event_status,
        execute_time: this.editForm.execute_time ? moment(this.editForm.execute_time).format('YYYY-MM-DD HH:mm:ss') : '',
        interval_value: this.editForm.interval_value,
        unit: this.editForm.unit,
        start_time: this.editForm.start_time ? moment(this.editForm.start_time).format('YYYY-MM-DD HH:mm:ss') : '',
        end_time: this.editForm.end_time ? moment(this.editForm.end_time).format('YYYY-MM-DD HH:mm:ss') : '',
        definition: this.aceEditor.getValue()
      }
      if (!reqData.name) {
        this.$Notice.error({
          title: '名称是必填的！'
        })
        return false
      } else if (!reqData.definition) {
        this.$Notice.error({
          title: '定义是必填的！'
        })
        return false
      } else if (reqData.event_type === 0 && reqData.execute_time === '') {
        this.$Notice.error({
          title: '请选择一次执行时间！'
        })
        return false
      } else if (reqData.event_type === 1 && (reqData.interval_value === '' || reqData.unit === '')) {
        this.$Notice.error({
          title: '请填写循环时间或循环单位！'
        })
        return false
      }
      if (this.callbackdata.event) {
        let isDiff = false
        for (let i in reqData) {
          if (reqData[i] !== this.old_data[i]) {
            isDiff = true
            break
          }
        }
        if (isDiff) {
          reqData._old_name = this.old_data.name
          reqData._old_type = this.old_data.type
          alterEvent(reqData).then(res => {
            this.$refs.WriteSqlModal.open(res.data.sql, 'event')
          })
        } else {
          this.$Notice.warning({
            title: '没有任何修改！'
          })
        }
      } else {
        createEvent(reqData).then(res => {
          this.$refs.WriteSqlModal.open(res.data.sql, 'event')
        })
      }
    },
    resetForm () {
      this.editForm = {
        name: '',
        definer: '',
        preserve: true,
        comment: '',
        event_type: 1,
        execute_time: '',
        interval_value: '',
        unit: '',
        event_status: 'ENABLE',
        start_time: '',
        end_time: ''
      }
      this.aceEditor.setValue('')
      if (this.callbackdata.event) {
        this.init()
      }
    },
    writeSQLComplete (sql) {
      this.CreateSqlComplete(sql)
    },
    // 开始执行SQL
    CreateSqlComplete (sql) {
      let data = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        sql: sql,
        limit: '100'
      }
      let that = this
      that.executing = true
      executeSQL(data).then(res => {
        let results = []
        res.data.results.forEach(function (item, index) {
          if (item['success']) {
            that.$Notice.success({
              title: '操作成功',
              desc: item['msg']
            })
            if (!that.callbackdata.event) {
              let pushData = {
                tab_id: that.callbackdata.id,
                db: that.callbackdata.db,
                event: that.editForm.name
              }
              that.$emit('callBack', 'createEventSuccess', pushData)
            } else {
              that.callbackdata.event = that.editForm.name
              that.init()
            }
          } else {
            that.$Notice.error({
              title: item['msg']
            })
          }
          results.push({'id': index + 1, 'res': item['data'], 'columns': [], 'msg': item['msg']})
          let cols = Object.keys(item['data'][0])
          if (cols) {
            cols.forEach(function (row) {
              results[index].columns.push({'title': row, 'key': row, 'minWidth': 130})
            })
          }
          that.execResultModal = true
        })
        that.executing = false
        that.$refs.SQLResults.showResult(results)
      }).catch(res => {
        that.executing = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.response
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    typeChange (type) {
      if (type === 'PROCEDURE') {
        this.editForm.return_type = ''
      }
    }
  }
}

</script>

<style scoped>
  .info-edit-form-button {
    background-color: #F5F7F9;
    text-align: center;
    height: 100px;
    display: block;
    line-height: 100px;
    margin-top: 10px;
  }
</style>
